import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Status } from '@models/status';
import { Observable } from 'rxjs';

/**
 * scope api service
 * @class ScopeService
 * @typedef {ScopeService}
 */
@Injectable( {
    providedIn: 'root'
} )
export class ScopeService {
    /** ignore in coverage */
    #httpClient = inject( HttpClient );

    /**
     * get overall status of scope services
     * e.g. status: { indicator: 'minor' | 'partial' | 'major' | 'maintenance'; description: string }
     * @returns object with current status
     */
    getStatus(): Observable<Status> {
        const statusApi = 'https://status.riege.com/api/v2/status.json';
        return this.#httpClient.get<Status>( statusApi ).pipe( ( res ) => res );
    }
}
